import React from 'react';
import HeroSection from '../components/home/HeroSection';
import ProductsCarousel from '../components/home/ProductsCarousel';
import BrandValuesSection from '../components/home/BrandValuesSection';
import ShowcaseSection from '../components/home/AboutBrandSection';
import Footer from '../components/layout/Footer';
import Header from '../components/layout/Header';
import FullWidthImage from "../components/home/FullWidthImage";

const Home = () => {
    return (
        <div className="min-h-screen">
            <Header />
            <HeroSection />
            <ProductsCarousel />
            <BrandValuesSection />
            {/*<ImpactSection />*/}
            <ShowcaseSection />
            <FullWidthImage />
            <Footer />
        </div>
    );
};

export default Home;